export enum TraversalDirection {
  In = 'in',
  Out = 'out',
  Both = 'both',
}
